import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PopupService } from 'src/app/services/popup.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss'
})
export class PopupComponent implements OnInit, OnDestroy {
  @Input() id: string = '';
  _open: boolean = false;
  tr(): TranslationService {
    return this._tr;
  }
  constructor(protected popup: PopupService, private _tr: TranslationService) {

  }
  ngOnInit() {
    if (this.id !== '') {
      this.popup.register(this.id, this)
    }
  }
  ngOnDestroy(): void {
    this.popup.unregister(this.id, this);
  }
  show() {
    console.log("asked to show: " + this.id);
    this._open = true;
  }
  hide() {
    console.log("asked to hide: " + this.id);
    this._open = false;
  }
  isOpen(): boolean {
    return this._open;
  }
}
